import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import FileWordTwoToneSvg from "@ant-design/icons-svg/es/asn/FileWordTwoTone";
import AntdIcon from "../components/AntdIcon";
var FileWordTwoTone = function FileWordTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileWordTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  FileWordTwoTone.displayName = 'FileWordTwoTone';
}
export default /*#__PURE__*/React.forwardRef(FileWordTwoTone);